import Vue from 'vue'
import axios from 'axios'
import { getConfig } from '../config'
import util from 'libs/util'
import user from '@/services/user'
import store from '@/store'
import qs1 from 'qs';

const TOKEN_KEY = 'LLSS_TOKEN';
let is401Request = false;

// axios 基础配置
const _axios = axios.create({
  baseURL: (process.env.NODE_ENV ===  'development' ? '' : process.env.VUE_APP_BASE_URL) + '/api',
  timeout: 1000 * 15,
  withCredentials: true
})


_axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem(TOKEN_KEY);
    console.log('==========================header===============', util.getStorage('orgaId'));
    if (token) {
      config.headers['token'] = token;
    }
    config.headers['logInOrgaId'] = util.getStorage('orgaId') || '';
    return config;
  },
  error => {
    return Promise.reject(error.msg)
  }
)

// 返回状态判断（添加响应拦截器）
_axios.interceptors.response.use(
  res => {
    if (res && res.data) {
      let data = res.data;
      if (data.status == 999) {
        Vue.prototype.$loading.hide();
        user.goLogin();
      } else {
        if (data.data && data.data.token) {
          util.setStorage(TOKEN_KEY, data.data.token);
        }
        return data;
      }
    }
    return res.data;
  },
  error => {
    const res = error.response;
    if (res) {
      const HTTP_STATUS = res.status;
      const data = res.data;
    }
    Vue.prototype.$loading.hide();
    return Promise.reject(error)
  }
)

const getReqUrl = (url) => {
  return url;
}
const req = {
  axios: _axios,
  /**
   * [get description]
   * @param  {[type]} url     [description]
   * @param  {[type]} params  [description]
   * @param  {Object} options [description]
   * @return {[type]}         [description]
   */
  get(url, params, options = {}) {
    return _axios.get(getReqUrl(url), {
      params,
      ...options,
    })
  },
  /**
   * [post description]
   * @param  {[type]} url     [description]
   * @param  {[type]} params  [description]
   * @param  {Object} options [description]
   * @return {[type]}         [description]
   */
  post(url, params, options = {}) {
    return _axios.post(getReqUrl(url), qs1.stringify(params), options)
  }
}

export default req
